import { all, takeEvery, put, call } from 'redux-saga/effects';
import { clientAccessActionTypes } from './ClientAccess.actionTypes';
import clientAccessService from '../../services/clientAccess';
import {
  addNotification,
  notificationStates,
} from '../../components/Notification';

function* getTeamClientsSaga({ payload }) {
  yield put({ type: clientAccessActionTypes.GET_TEAM_CLIENTS_PENDING });
  const response = yield call(
    clientAccessService.getTeamClientAccess,
    payload.companyId,
    payload.teamId
  );
  if (response.success) {
    yield put({
      type: clientAccessActionTypes.GET_TEAM_CLIENTS_SUCCESS,
      payload: response.data,
    });
  } else {
    yield put({ type: clientAccessActionTypes.GET_TEAM_CLIENTS_FAILED });
  }
}

function* revokeClientAccessSaga({ payload }) {
  yield put({ type: clientAccessActionTypes.REVOKE_CLIENT_ACCESS_PENDING });
  const response = yield call(clientAccessService.revokeClientAccess, payload);
  if (response.success) {
    yield put({ type: clientAccessActionTypes.REVOKE_CLIENT_ACCESS_SUCCESS });
    addNotification({
      message: response.message || 'Client access revoked',
      level: notificationStates.success,
    });
    if (payload.companyId && payload.teamId) {
      yield put({
        type: clientAccessActionTypes.GET_TEAM_CLIENTS,
        payload: { companyId: payload.companyId, teamId: payload.teamId },
      });
    }
  } else {
    yield put({
      type: clientAccessActionTypes.REVOKE_CLIENT_ACCESS_FAILED,
      payload: response,
    });
    addNotification({
      message: response.message || 'Failed to revoke client access',
      level: notificationStates.error,
    });
  }
}

export default function* clientAccessWatcher() {
  yield all([
    takeEvery(clientAccessActionTypes.GET_TEAM_CLIENTS, getTeamClientsSaga),
    takeEvery(
      clientAccessActionTypes.REVOKE_CLIENT_ACCESS,
      revokeClientAccessSaga
    ),
  ]);
}
